import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal } from 'react-bootstrap';

import { GlobalManufacturerHarvestStatusLabels } from 'lib/enums/GlobalManufacturerHarvestStatus';

function StatusConfirmationModal({
  show,
  onHide,
  onConfirm,
  manufacturerName,
  newStatus,
  isLoading,
}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Status Change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to change the status for <strong>{manufacturerName}</strong> to{' '}
          <strong>{GlobalManufacturerHarvestStatusLabels[newStatus]}</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Updating...' : 'Confirm'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

StatusConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  manufacturerName: PropTypes.string.isRequired,
  newStatus: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

export default StatusConfirmationModal;
